module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-4-75.0510f6ef.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-4-75.png
// module id = 2561
// module chunks = 11